/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTipoRegimen from 'Infotrack@Modelos/administracion/tipoRegimen';
import ITipoRegimen from 'Infotrack@Modelos/administracion/tipoRegimen/entidades/tipoRegimen';

export default class ControladorModeloTipoRegimen {
    private modeloTipoRegimen: ModeloTipoRegimen;
    constructor() {
        this.modeloTipoRegimen = new ModeloTipoRegimen();
    }

    public consultarTipoRegimen() {
        return this.modeloTipoRegimen.consultarTipoRegimen().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTipoRegimen(tipoRegimen: ITipoRegimen) {
        await this.modeloTipoRegimen.crearTipoRegimen(tipoRegimen);
    }

    public async editarTipoRegimen(tipoRegimen: ITipoRegimen) {
        await this.modeloTipoRegimen.editarTipoRegimen(tipoRegimen);
    }

    public async eliminarTipoRegimen(tipoRegimen: ITipoRegimen) {
        await this.modeloTipoRegimen.eliminarTipoRegimen(tipoRegimen);
    }

    public validarEntidad(tipoRegimen: ITipoRegimen): boolean {
        if (tipoRegimen.CodigoTipoRegimen === '' || tipoRegimen.NombreTipoRegimen === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
